export default {
      id: "logo-new-usage",
      viewBox: "0 0 182 45",
      url: __webpack_public_path__ + "svgsprite.svg#logo-new",
      toString: function () {
        return this.url;
      }
    }